import script from "./AlertsIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertsIcon.vue?vue&type=script&setup=true&lang=js"

import "./AlertsIcon.vue?vue&type=style&index=0&id=69217558&lang=scss"

const __exports__ = script;

export default __exports__